/**
 * Development-only logging.
 *
 * Production builds printed ~170 console.log calls - payment receipts,
 * GraphQL payloads, auth state and step-by-step traces - into every
 * customer's browser console. CRA inlines NODE_ENV, so in a production
 * build this is an empty function and nothing is printed - including values
 * like the Moneris dataKey, which production used to print. Literal message
 * text still ships in the bundle, so never hard-code a secret in one.
 * Keep console.warn / console.error for real problems.
 */
export const debugLog: (...args: unknown[]) => void =
  process.env.NODE_ENV === 'production'
    ? () => undefined
    : // eslint-disable-next-line no-console
      (...args: unknown[]) => console.log(...args);
